import { render } from "./basic-layout.vue?vue&type=template&id=a8e30ce8&ts=true"
import script from "./basic-layout.vue?vue&type=script&lang=ts"
export * from "./basic-layout.vue?vue&type=script&lang=ts"

import "./basic-layout.vue?vue&type=style&index=0&id=a8e30ce8&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__